import { Spacer } from '../Spacer'

export function AvisoLegalContent() {
  return (
    <div className="flex flex-col gap-2">
      <h1 className={`w-full px-0 text-h4 text-neutral-900`}>AVISO LEGAL</h1>
      <Spacer size="32px" />
      <p className="flex w-full flex-col gap-2">
        En cumplimiento de lo dispuesto en la Ley 34/2002, de 11 de julio, de
        Servicios de la Sociedad de la Información y de Comercio Electrónico
        (LSSI-CE), se informa a los usuarios de los siguientes datos:
      </p>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>1. DATOS IDENTIFICATIVOS</h2>
        <div className="flex flex-col gap-2">
          <p>
            <span className="font-bold">Titular de la web:</span> Gama Óptima,
            S.L.
          </p>
          <p>
            <span className="font-bold">CIF:</span> B75429340
          </p>
          <p>
            <span className="font-bold">Domicilio social:</span> Ronda General
            Mitre 38-40, Local comercial sótano 1, 08017 Barcelona
          </p>
          <p>
            Correo electrónico de contacto:
            <span className="font-bold">info@gamaoptima.com</span>
          </p>
          <p>
            La presente web tiene por objeto ofrecer información sobre los
            servicios de compraventa de vehículos, financiación, vehículos bajo
            demanda y otros servicios relacionados con el sector de la
            automoción.
          </p>
        </div>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>2. CONDICIÓN DE USUARIO</h2>
        <p>
          El acceso y/o uso de este sitio web atribuye la condición de{' '}
          <span className="font-bold">usuario</span>, que acepta, desde dicho
          acceso y/o uso, las condiciones aquí reflejadas. Estas condiciones
          serán de aplicación independientemente de las condiciones generales de
          contratación que, en su caso, resulten de obligado cumplimiento.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>3. USO DEL SITIO WEB</h2>
        <p>
          El usuario se compromete a hacer un uso adecuado de los contenidos y
          servicios que Gama Óptima, S.L. ofrece a través de su web y, con
          carácter enunciativo pero no limitativo, a no utilizarlos para:
        </p>
        <ul className="ml-6 flex list-disc flex-col gap-2">
          <li>
            Realizar actividades ilícitas, ilegales o contrarias a la buena fe y
            al orden público.
          </li>
          <li>
            Provocar daños en los sistemas físicos y lógicos de Gama Óptima,
            S.L., de sus proveedores o de terceras personas.
          </li>
          <li>
            Introducir o difundir virus informáticos o cualesquiera otros
            sistemas que sean susceptibles de provocar daños.
          </li>
        </ul>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>
          4. PROPIEDAD INTELECTUAL E INDUSTRIAL
        </h2>
        <p>
          Todos los contenidos del sitio web, incluyendo textos, imágenes,
          diseño gráfico, logotipos, iconos, software, nombres comerciales,
          marcas o cualquier otro signo susceptible de utilización industrial y
          comercial, están protegidos por los derechos de propiedad intelectual
          e industrial de <span className="font-bold">Gama Óptima, S.L.</span> o
          de terceros titulares que han autorizado su uso.
        </p>
        <p>
          Queda expresamente prohibida la reproducción, distribución,
          comunicación pública o transformación de dichos contenidos sin la
          autorización expresa del titular de los derechos.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>5. RESPONSABILIDAD</h2>
        <p>
          Gama Óptima, S.L. no se hace responsable de los daños o perjuicios de
          cualquier naturaleza que pudieran derivarse de:
        </p>
        <ul className="ml-6 flex list-disc flex-col gap-2">
          <li>Errores u omisiones en los contenidos.</li>
          <li>Falta de disponibilidad del sitio web.</li>
          <li>
            La transmisión de virus o programas maliciosos, pese a haber
            adoptado todas las medidas tecnológicas necesarias para evitarlo.
          </li>
        </ul>
        <p>
          El uso de la web se realiza bajo la exclusiva responsabilidad del
          usuario.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>6. ENLACES A TERCEROS</h2>
        <p>
          En el caso de que en la web se dispusiesen enlaces o hipervínculos
          hacia otros sitios de Internet, Gama Óptima, S.L. no ejercerá ningún
          tipo de control sobre dichos sitios y contenidos, y no asumirá
          responsabilidad alguna por los mismos.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>7. PROTECCIÓN DE DATOS</h2>
        <p>
          El tratamiento de los datos personales del usuario se regirá por lo
          dispuesto en la{' '}
          <span className={`font-bold`}>Política de Privacidad</span>, accesible
          desde este mismo sitio web.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>8. MODIFICACIONES</h2>
        <p>
          Gama Óptima, S.L. se reserva el derecho a modificar el presente Aviso
          Legal en cualquier momento, sin necesidad de previo aviso, siendo
          debidamente publicadas en el sitio web.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>
          9. LEGISLACIÓN APLICABLE Y JURISDICCIÓN
        </h2>
        <p>
          La relación entre Gama Óptima, S.L. y el usuario se regirá por la
          normativa española vigente. Cualquier controversia se someterá a los{' '}
          <span className="font-bold">
            Juzgados y Tribunales de la ciudad de Barcelona
          </span>
          , salvo que la normativa aplicable disponga otra cosa.
        </p>
      </section>
    </div>
  )
}
